import {
  Entity,
  Column,
  PrimaryGeneratedColumn,
  Index,
  ManyToMany,
} from "typeorm";

import { Role } from "./Role";

@Entity()
export class Permission {
  @PrimaryGeneratedColumn() id: number;

  @Index({ unique: true })
  @Column("varchar")
  slug: string;

  @Column("varchar") name: string;

  @ManyToMany((type) => Role)
  roles: Role[];
}
